/**
 * Get the browser width of the page.
 * Not including permanent scroll bars on Windows.
 * Ignoring the temporary/hovering scrollbars on macOS and iOS.
 */
export default function () {
  return document.documentElement.clientWidth
}
